import React from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { BasicAction } from "widgets/ActionMenu";

export default function ContentFeedUpdatesHistory({ contentFeedId, contentFeedName, libraryId }) {
	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(push({
			pathname: `/library/${libraryId}/content-feeds/${contentFeedId}/updates-history/`,
			state: {
				contentFeedName,
			},
		}));
	};

	return (
		<BasicAction
			name="Updates History"
			iconName="fas fa-history"
			handleClick={handleClick}
		/>
	);
}

ContentFeedUpdatesHistory.displayName = "ContentFeedUpdatesHistory";

